import {styled} from "@mui/material/styles";
import {ListItem} from "@mui/material";

export const TotalAmount = styled('span')(({theme}) => ({
	fontFamily: 'Circular',
	fontSize: '56px',
	lineHeight: '78px',
	fontWeight: 800,
	color: theme.palette.primary.light
}))

export const TotalAmountChip = styled('span')(({theme}) => ({
	backgroundColor: theme.palette.primary.light,
	color: '#fff',
	borderRadius: '15px',
	fontFamily: 'Circular',
	fontWeight: 600,
	fontSize: '14px',
	lineHeight: '22px',
	padding: '1px 16px',
}))

export const BorderBlock = styled('div')(({theme}) => ({
	borderRadius: theme.shape.borderRadius,
	backgroundColor: theme.palette.background.default,
	padding: theme.spacing(3),
	border: `1px solid ${theme.palette.secondary.main ?? "#CDD8DE"}`
}))

export const ListElement = styled(ListItem)(() => ({
	padding: '10px 0px',
	justifyContent: 'space-between'
}))
export const ListLeftText = styled('div')(({theme}) => ({
	fontSize: theme.typography.subtitle2.fontSize,
	lineHeight: theme.typography.subtitle2.lineHeight,
	color: theme.typography.subtitle2.color,
	fontWeight: 400,
}))
export const ListRightText = styled('div')(({theme}) => ({
	fontSize: theme.typography.subtitle2.fontSize,
	lineHeight: theme.typography.subtitle2.lineHeight,
	color: theme.typography.subtitle2.color,
	fontWeight: 700,
	textAlign: 'right'
}))
